import { Badge } from '@/components/ui/Badge'
import type { Revenue } from '@/services/modules/RevenuesService'

/**
 * Origem da cobrança da fatura.
 *
 * A verdade vem de `hasAsaasCharge`, gravado quando o sistema consulta o Asaas
 * (no "Resincronizar Asaas" ou em qualquer movimentação da fatura). O `gateway`
 * não serve: há faturas marcadas ASAAS que nunca tiveram cobrança, e cobranças
 * apagadas no Asaas cuja fatura foi paga por PIX.
 *
 * Enquanto a fatura nunca foi verificada, mostramos o palpite pelo vínculo com
 * um "?" — sinalizando que aquilo ainda não foi confirmado no gateway.
 */
export function AsaasBadge({ revenue }: { revenue: Revenue }) {
  if (revenue.hasAsaasCharge === true) {
    return <Badge variant="blue">Asaas</Badge>
  }
  if (revenue.hasAsaasCharge === false) {
    return <Badge variant="gray">Sistema</Badge>
  }

  // Nunca verificada: palpite pelo vínculo (as faturas importadas do sistema
  // antigo guardam o `pay_...` no código, e não no id externo).
  const looksAsaas = !!revenue.externalId || (revenue.code ?? '').startsWith('pay_')
  return (
    <span title="Ainda não verificado no Asaas — use “Resincronizar Asaas”.">
      <Badge variant="amber">{looksAsaas ? 'Asaas?' : 'Sistema?'}</Badge>
    </span>
  )
}
